import React from "react";

const CourierInfo = () => {
  return (
    <div className="courier">
      <p>
        <span>택배사</span>
        <span>한진택배</span>
      </p>
      <p>
        <span>송장번호</span>
        <span>05123148623165</span>
      </p>
      <button className="btn">택배사 전화하기</button>
    </div>
  );
};

export default CourierInfo;
